import { WizardStep } from '@/types/enums.type';
import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('Wizard', ['isLoading'])
  }
})
export default class WizardMixin extends Vue {
  loading!: boolean;

  setLoading(value: boolean): void {
    this.$store.commit('Wizard/updateField', {
      path: "loading",
      value: value
    });
  }

  next(step: WizardStep): void {
    this.$store.commit('Wizard/updateField', {
      path: 'currentStep',
      value: step
    });
  }
}